// extracted by mini-css-extract-plugin
export default {"frame":"recentes_frame__jc8FI","frameSquare":"recentes_frameSquare__PLvum","imagem":"recentes_imagem__f0Kt6","marca":"recentes_marca__DSIuV","modelo":"recentes_modelo__vwzAn"};